import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Platform } from 'react-native';

import { CustomNavigationHeader } from '@garnish/navigation';

import { type ScanToPayPalette } from '../../utils';

export const ScanToPayTabsHeader = (props: ScanToPayTabsHeaderProps) => {
  const { palette, onClose } = props;
  const { formatMessage } = useIntl();

  return (
    <CustomNavigationHeader.Container
      palette={palette}
      safeAreaEdges={Platform.OS === 'android' ? ['top'] : []}
    >
      <CustomNavigationHeader.Button.Right
        name="IconClose"
        palette={palette === 'cream' ? 'muted' : 'premium'}
        accessibilityLabel={formatMessage(messages.close)}
        onPress={onClose}
      />
    </CustomNavigationHeader.Container>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  close: {
    defaultMessage: 'Close',
    description: 'Scan To Pay | Header | Close',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayTabsHeaderProps = {
  palette: ScanToPayPalette;
  onClose: () => void;
};
